export const MARKER_OPACITY_AT_LOW_ZOOM = 0.7;
export const MARKER_OPACITY_AT_HIGH_ZOOM = 0.2;
